import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, Transition as _Transition, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import VPHome from '@theme/VPHome.vue'
import VPNavbar from '@theme/VPNavbar.vue'
import VPPage from '@theme/VPPage.vue'
import VPSidebar from '@theme/VPSidebar.vue'
import { useScrollPromise } from '@theme/useScrollPromise'
import { useSidebarItems } from '@theme/useSidebarItems'
import { useThemeLocaleData } from '@theme/useThemeData'
import type { VNode } from 'vue'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { usePageData, usePageFrontmatter, useRouter } from 'vuepress/client'
import type { DefaultThemePageFrontmatter } from '../../shared/index.js'


export default /*@__PURE__*/_defineComponent({
  __name: 'Layout',
  setup(__props) {



const page = usePageData()
const frontmatter = usePageFrontmatter<DefaultThemePageFrontmatter>()
const themeLocale = useThemeLocaleData()

// navbar
const shouldShowNavbar = computed(
  () =>
    frontmatter.value.navbar !== false && themeLocale.value.navbar !== false,
)

// sidebar
const sidebarItems = useSidebarItems()
const isSidebarOpen = ref(false)
const toggleSidebar = (to?: boolean): void => {
  isSidebarOpen.value = typeof to === 'boolean' ? to : !isSidebarOpen.value
}
const touchStart = { x: 0, y: 0 }
const onTouchStart = (e: TouchEvent): void => {
  touchStart.x = e.changedTouches[0].clientX
  touchStart.y = e.changedTouches[0].clientY
}
const onTouchEnd = (e: TouchEvent): void => {
  const dx = e.changedTouches[0].clientX - touchStart.x
  const dy = e.changedTouches[0].clientY - touchStart.y
  if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
    if (dx > 0 && touchStart.x <= 80) {
      toggleSidebar(true)
    } else {
      toggleSidebar(false)
    }
  }
}

// external-link-icon
const enableExternalLinkIcon = computed(
  () =>
    frontmatter.value.externalLinkIcon ??
    themeLocale.value.externalLinkIcon ??
    true,
)

// classes
const containerClass = computed(() => [
  {
    'no-navbar': !shouldShowNavbar.value,
    'no-sidebar': !sidebarItems.value.length,
    'sidebar-open': isSidebarOpen.value,
    'external-link-icon': enableExternalLinkIcon.value,
  },
  frontmatter.value.pageClass,
])

// close sidebar after navigation
let unregisterRouterHook: () => void
onMounted(() => {
  const router = useRouter()
  unregisterRouterHook = router.afterEach(() => {
    toggleSidebar(false)
  })
})
onUnmounted(() => {
  unregisterRouterHook()
})

// handle scrollBehavior with transition
const scrollPromise = useScrollPromise()
const onBeforeEnter = scrollPromise.resolve
const onBeforeLeave = scrollPromise.pending

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["vp-theme-container", containerClass.value]),
    "vp-container": "",
    onTouchstart: onTouchStart,
    onTouchend: onTouchEnd
  }, [
    _renderSlot(_ctx.$slots, "navbar", {}, () => [
      (shouldShowNavbar.value)
        ? (_openBlock(), _createBlock(VPNavbar, {
            key: 0,
            onToggleSidebar: toggleSidebar
          }, {
            before: _withCtx(() => [
              _renderSlot(_ctx.$slots, "navbar-before")
            ]),
            after: _withCtx(() => [
              _renderSlot(_ctx.$slots, "navbar-after")
            ]),
            _: 3
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "vp-sidebar-mask",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSidebar(false)))
    }),
    _renderSlot(_ctx.$slots, "sidebar", {}, () => [
      _createVNode(VPSidebar, null, {
        top: _withCtx(() => [
          _renderSlot(_ctx.$slots, "sidebar-top")
        ]),
        bottom: _withCtx(() => [
          _renderSlot(_ctx.$slots, "sidebar-bottom")
        ]),
        _: 3
      })
    ]),
    _renderSlot(_ctx.$slots, "page", {}, () => [
      (_unref(frontmatter).home)
        ? (_openBlock(), _createBlock(VPHome, { key: 0 }))
        : (_openBlock(), _createBlock(_Transition, {
            key: 1,
            name: "fade-slide-y",
            mode: "out-in",
            onBeforeEnter: _unref(onBeforeEnter),
            onBeforeLeave: _unref(onBeforeLeave)
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(VPPage, {
                key: _unref(page).path
              }, {
                top: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "page-top")
                ]),
                "content-top": _withCtx(() => [
                  _renderSlot(_ctx.$slots, "page-content-top")
                ]),
                "content-bottom": _withCtx(() => [
                  _renderSlot(_ctx.$slots, "page-content-bottom")
                ]),
                bottom: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "page-bottom")
                ]),
                _: 3
              }))
            ]),
            _: 3
          }, 8, ["onBeforeEnter", "onBeforeLeave"]))
    ])
  ], 34))
}
}

})